exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "\n.tab-item[data-v-4717a40c] {\n    padding: 16px;\n}\n.tab-item h3[data-v-4717a40c] {\n    border-bottom: 1px solid #999;\n}\n.tab-item p[data-v-4717a40c] {\n    margin: 10px 5px;\n}\n", ""]);

